export default __webpack_public_path__ + "static/media/EasyRecipeazy.4e651172.png";